module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/lodash/extend.js
// module id = yyCt
// module chunks = 0